import { jsx as _jsx } from "react/jsx-runtime";
import ExpandDownIcon from "@diligentcorp/atlas-react-icons/ExpandDown.js";
const getCardTokens = (tokens) => {
    return {
        card: tokens.component.card,
        color: tokens.semantic.color,
    };
};
export const cardPresets = (tokens) => {
    const { card } = getCardTokens(tokens);
    return {
        collapsible: {
            sx: {
                gap: 0,
                padding: 0,
                overflow: "visible",
                ".MuiCardActionArea-root:focus-visible": {
                    borderRadius: card.borderRadius.value,
                    boxShadow: card.focus.boxShadow.value.stringValue,
                },
                ".MuiCardActionArea-focusHighlight": {
                    background: "none",
                },
                ".MuiCardHeader-root": {
                    padding: tokens.semantic.spacing.lg.value,
                    ".MuiCardHeader-action": {
                        margin: "auto 0",
                    },
                },
                ".MuiCardContent-root": {
                    "&:last-child": {
                        paddingBottom: tokens.semantic.spacing.lg.value,
                    },
                    paddingLeft: tokens.semantic.spacing.lg.value,
                    paddingRight: tokens.semantic.spacing.lg.value,
                    paddingTop: tokens.semantic.spacing.lg.value,
                },
            },
        },
        groupWrapper: {
            sx: {
                outline: card.group.outline.value,
                borderRadius: card.borderRadius.value,
                ".MuiCard-root": {
                    borderBottom: card.group.border.value,
                    borderRadius: 0,
                    "&:last-child": {
                        borderBottom: 0,
                    },
                },
            },
        },
        HeaderAction: ({ isExpanded, theme, icon = ExpandDownIcon, }) => {
            var _a, _b, _c;
            const Icon = icon;
            return (_jsx(Icon, { style: {
                    marginLeft: "auto",
                    fontSize: tokens.semantic.iconSize.lg.value,
                    transform: `rotate(${isExpanded ? 180 : 0}deg)`,
                    transition: (_b = (_a = theme.transitions) === null || _a === void 0 ? void 0 : _a.create) === null || _b === void 0 ? void 0 : _b.call(_a, "transform", {
                        duration: (_c = theme.transitions.duration) === null || _c === void 0 ? void 0 : _c.shortest,
                    }),
                } }));
        },
    };
};
//# sourceMappingURL=card.js.map